import firebase from 'firebase'
import store from '@/store'

export default {
  profileIcon() {
    return store.state.user.photoURL
  },
  displayName() {
    return store.state.user.displayName
  },
  isInPurchaseView() {
    return store.state.user.isInPurchaseView
  },
  updatePurchaseView(val) {
    store.commit('updateIsInPurchaseView', val)
  },
  firestoreLogin() {
    const provider = new firebase.auth.GoogleAuthProvider()

    firebase.auth().signInWithPopup(provider).then(res => {
      console.log(res)
      store.commit('updateDisplayName', res.user.displayName)
      store.commit('updatePhtoURL', res.user.photoURL)
    }).catch(err => {
      console.log(err)
    })
  },
  firestoreSignOut() {
    firebase.auth().signOut().then(() => {
      store.commit('updateDisplayName', null)
      store.commit('updatePhtoURL', null)
    }).catch(err => {
      console.log(err)
    })
  }
}
